import { useEffect, useRef, useState } from "react";

// Giacomo — la mascotte di Amunì. Compare a intervalli casuali con frasi motivazionali.
// Zero donazioni, zero call-to-action commerciali. Solo incoraggiamento per i ragazzi.

const COLORS = [
  { color: "#E53935", url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_culto-vote/artifacts/usqsv43m_GIACOMO%20-%203.PNG" },
  { color: "#12BFB2", url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_culto-vote/artifacts/861xy0ok_GIACOMO%20-%205.PNG" },
  { color: "#A5E070", url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_culto-vote/artifacts/oic7s58i_GIACOMO%20-%206.PNG" },
];

const WELCOME_PHRASES = [
  (name) => `Bentornato ${name?.split(" ")[0] || "amico"}! Oggi facciamo la differenza 🤙`,
  (name) => `Ehi ${name?.split(" ")[0] || "campione"}! Bello riavervi qui 🌊`,
  () => `Amunì! È il momento di dare il massimo`,
  (name) => `Ciao ${name?.split(" ")[0] || "socio"}! Cassibile ha bisogno di te`,
];

const MOTIVATION_PHRASES = [
  "Ogni piccolo gesto conta. Continua così! 💪",
  "Sei parte di qualcosa di grande. Non mollare mai 🌟",
  "Un socio attivo vale più di mille parole. Bravo!",
  "La forza dell'Associazione siete voi ragazzi 🔥",
  "Impegnati oggi, ricorderai domani con orgoglio",
  "Amunì! Un passo alla volta si costruiscono grandi cose",
  "La tua voce nella votazione fa la differenza 🗳️",
  "Cassibile ha bisogno di gente come te ❤️",
  "Anche una buona idea può cambiare la comunità 💡",
  "Sei il motivo per cui questa Associazione esiste 🌈",
  "Dai il tuo meglio, il Consiglio ti guarda con orgoglio 👏",
  "Ogni riunione è un\u2019occasione per crescere insieme",
];

// ============================================================
// GABRIEL ROSSITTO — trattamento speciale (solo per lui).
// Sfottò affettuosi in dialetto siciliano, mai offensivi.
// ============================================================
const GABRIEL_WELCOME_PHRASES = [
  "Talé cu' c'è! Ancora nun t'hannu cacciatu? 😏",
  "Gabriè, arrivasti tu? Allura oggi si travagghia picca 🍺",
  "Ah Gabriè, pinsavu ca ti eri persu 'nta na birra... e invece no!",
  "Amunì Gabriè, cu' tia c'è sempri du' problema... unu è ca arrivi, l'autru è ca resti 😂",
  "Talè talè, Gabriè! Facemu na fotu prima ca sparisci arrè",
];

const GABRIEL_MOTIVATION_PHRASES = [
  "Gabriè, sì cchiù lentu di na tartaruga cu 'nu saccu i petri 🐢",
  "Gabriè, vuoi votari? Prima leggi u regolamentu... ah no, ca nun sai leggiri 😆",
  "Gabriè, ma unni ci vai vistutu accussì? Ammunì a travagghiari!",
  "Ancora ccà si Gabriè? Chi camurria stamatina 💚",
  "Gabriè, sì cchiù nfamu ri na iurnata i sciroccu 🌪️",
  "Gabriè, paghi 'a tessera o ti manniamu Giacumu a casa tò?",
  "Gabriè, ju ti vogghiu beni, ma sì propriu 'na camurria oggi 😂",
  "Talé Gabriè, ma sempri ccà stai? Ti pigghiamu 'nta libbru paga!",
  "Gabriè, u sacciu ca sì bellu, ma sti riunioni ti perdi sempri 🙄",
  "Gabriè, cchiù ti taliu e cchiù mi cummincu ca ti nfilasti 'e straforo 🕵️",
  "Gabriè, ti vitti aieri e già mi mancavi... picchì ti vidu arrè, ma sinceramenti 😅",
  "Gabriè, tu vota tuttu e chiudi 'ntempu, ca a mia mi scoccia 🗳️",
  "Talè Gabriè, u tempu ca ci mitti tu a decidiri, iu m'hai già bivutu 'na Peroni 🍻",
  "Gabriè, u sai chi si dici a Cassibbili? Ca sì bravu ragazzu... ma sulu quannu dormi 😴",
  "Gabriè, ju scherzu, cà tu u sai... o forsi no, ca 'un capisci mai nenti 😜",
  "Gabriè, cu tia ci vuli 'a paccenza ri Giobbi, ma cu 'na birra 'mmanu 🍺",
  "Amunì Gabriè, movi ssi mani! O aspetti ca u Consigliu ti purtassi u caffè?",
];

function _isGabriel(name) {
  if (!name) return false;
  const s = String(name).toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return s.includes("gabriel") && s.includes("rossitto");
}
// ============================================================

function pick(a) { return a[Math.floor(Math.random() * a.length)]; }

export default function GiacomoMascot({ userName, onOpenChat }) {
  const [visible, setVisible] = useState(false);
  const [speak, setSpeak] = useState(false);
  const [shaka, setShaka] = useState(false);
  const [choice, setChoice] = useState(COLORS[0]);
  const [text, setText] = useState("");
  const [dismissed, setDismissed] = useState(false);
  const apparitionsRef = useRef(0);
  const firstRef = useRef(true);

  const trigger = (isWelcome, customText) => {
    if (dismissed) return;
    if (apparitionsRef.current >= 5 && !customText) return;
    if (document.hidden) return;
    apparitionsRef.current += 1;

    const isGabriel = _isGabriel(userName);
    setChoice(pick(COLORS));
    if (customText) {
      setText(customText);
    } else if (isWelcome) {
      // Gabriel gets his own sarcastic welcome — always
      setText(isGabriel ? pick(GABRIEL_WELCOME_PHRASES) : pick(WELCOME_PHRASES)(userName));
    } else {
      // Gabriel gets the Sicilian teasing pool instead of motivation
      setText(isGabriel ? pick(GABRIEL_MOTIVATION_PHRASES) : pick(MOTIVATION_PHRASES));
    }
    setVisible(true);
    setTimeout(() => setShaka(true), 350);
    setTimeout(() => setSpeak(true), 700);
    setTimeout(() => {
      setSpeak(false); setShaka(false); setVisible(false);
    }, 7200);
  };

  useEffect(() => {
    try { if (sessionStorage.getItem("gm-app-hidden") === "1") setDismissed(true); } catch { /* ignore */ }
    // Welcome comparsa dopo login
    const t1 = setTimeout(() => {
      if (firstRef.current) { firstRef.current = false; trigger(true); }
    }, 2500);
    // Successive comparse: ogni 90-180 secondi
    const t2 = setInterval(() => trigger(false), 90000 + Math.random() * 90000);
    // Event-triggered comparse (da altre componenti)
    const onSay = (e) => trigger(false, e.detail?.text);
    window.addEventListener("giacomo:say", onSay);
    return () => { clearTimeout(t1); clearInterval(t2); window.removeEventListener("giacomo:say", onSay); };
  }, []); // eslint-disable-line

  const dismiss = () => {
    setDismissed(true); setVisible(false); setSpeak(false); setShaka(false);
    try { sessionStorage.setItem("gm-app-hidden", "1"); } catch { /* ignore */ }
  };

  return (
    <>
      <style>{`
        .gm-root { position: fixed; right: 20px; bottom: 90px; z-index: 60; width: 120px; height: 148px; pointer-events: none; opacity: 0; transform: translateY(120%) rotate(-6deg); transition: opacity 0.4s cubic-bezier(.2,.9,.3,1.4), transform 0.55s cubic-bezier(.2,.9,.3,1.4); }
        .gm-root.gm-in .gm-body { pointer-events: auto; cursor: pointer; }
        .gm-root.gm-in { opacity: 1; transform: translateY(0) rotate(0deg); }
        .gm-body { position: absolute; inset: 0; background-repeat: no-repeat; background-position: center; background-size: contain; filter: drop-shadow(0 6px 18px rgba(0,0,0,0.12)); }
        .gm-root.gm-shaka .gm-body { animation: gm-shaka 1.2s ease-in-out 2; transform-origin: 50% 90%; }
        .gm-eyelid { position: absolute; left: 30%; top: 32%; width: 8%; height: 5%; background: currentColor; border-radius: 50%; transform: scaleY(0); }
        .gm-root.gm-shaka .gm-eyelid { animation: gm-wink 1s ease-in-out 1; }
        .gm-bubble { position: absolute; bottom: 100%; right: 100%; margin-right: 12px; width: 220px; background: #fff; color: #1F2A24; border: 1.5px solid currentColor; border-radius: 14px; padding: 12px 14px; font-size: 13px; line-height: 1.4; box-shadow: 0 8px 24px rgba(0,0,0,0.1); opacity: 0; transform: translateY(6px); transition: opacity 0.3s ease, transform 0.3s ease; font-weight: 500; font-family: 'Plus Jakarta Sans', system-ui, sans-serif; }
        .gm-bubble::after { content: ""; position: absolute; left: 100%; top: 60%; border: 8px solid transparent; border-left-color: currentColor; }
        .gm-root.gm-speak .gm-bubble { opacity: 1; transform: translateY(0); }
        .gm-close { position: absolute; top: -8px; right: -8px; width: 24px; height: 24px; background: #fff; color: #6B6558; border: 1px solid #E8E2D8; border-radius: 50%; font-size: 14px; line-height: 22px; text-align: center; cursor: pointer; pointer-events: auto; opacity: 0; transition: opacity 0.2s; padding: 0; }
        .gm-root.gm-in .gm-close { opacity: 1; }
        .gm-close:hover { background: #FDF2F2; color: #EF3E36; }
        @keyframes gm-shaka { 0%{transform:rotate(0) translateY(0)} 15%{transform:rotate(-14deg) translateY(-4px)} 30%{transform:rotate(12deg) translateY(-4px)} 45%{transform:rotate(-10deg) translateY(-2px)} 60%{transform:rotate(8deg) translateY(-2px)} 75%{transform:rotate(-4deg) translateY(0)} 100%{transform:rotate(0) translateY(0)} }
        @keyframes gm-wink { 0%,30%,100%{transform:scaleY(0);opacity:0.001} 40%,60%{transform:scaleY(1.6);opacity:1} }
        @media (prefers-reduced-motion: reduce) { .gm-root{transition:opacity 0.3s ease;transform:none!important} .gm-root.gm-shaka .gm-body,.gm-root.gm-shaka .gm-eyelid{animation:none} }
        @media (max-width: 640px) {
          .gm-root { width: 88px; height: 108px; right: 12px; bottom: 140px; }
          .gm-bubble { width: 200px; font-size: 12px; right: 0; left: auto; bottom: 100%; margin: 0 0 12px 0; }
          .gm-bubble::after { left: auto; right: 20px; top: 100%; border: 8px solid transparent; border-top-color: currentColor; border-left-color: transparent; }
        }
      `}</style>
      <div
        className={`gm-root ${visible ? "gm-in" : ""} ${shaka ? "gm-shaka" : ""} ${speak ? "gm-speak" : ""}`}
        style={{ color: choice.color }}
        aria-hidden={!visible}
        data-testid="giacomo-mascot"
      >
        <div className="gm-bubble" data-testid="giacomo-bubble">{text}</div>
        <div className="gm-body" style={{ backgroundImage: `url("${choice.url}")` }} onClick={() => onOpenChat && onOpenChat()} title="Chiedi a Giacomo" />
        <div className="gm-eyelid" />
        <button className="gm-close" onClick={dismiss} aria-label="Chiudi mascotte" data-testid="giacomo-close">×</button>
      </div>
    </>
  );
}
